var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80437 2.73799L12.5 10.0966L23.1956 2.73799C23.0163 2.1488 22.4569 1.71429 21.8023 1.71429H3.19767C2.54308 1.71429 1.98374 2.1488 1.80437 2.73799ZM23.2558 4.78914L13.0001 11.8451C12.6998 12.0517 12.3002 12.0517 11.9999 11.8451L1.74419 4.78914V16.8571C1.74419 17.6409 2.40025 18.2857 3.19767 18.2857H21.8023C22.5998 18.2857 23.2558 17.6409 23.2558 16.8571V4.78914ZM0 3.14286C0 1.41233 1.43696 0 3.19767 0H21.8023C23.563 0 25 1.41233 25 3.14286V16.8571C25 18.5877 23.563 20 21.8023 20H3.19767C1.43696 20 0 18.5877 0 16.8571V3.14286Z",
    fill: "#F2F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.3489ca35c21ef77a73c2ad2a633fb470.svg";
export { ForwardRef as ReactComponent };